import React, { useState, useEffect } from "react";

import { Form, Col } from "react-bootstrap";

import Selecter from "../../common/Selecter";

import {
  CATEGORIES,
  DUE_DATES,
  LEVELS,
  LOCATIONS,
  NATIONALITIES,
  OPP_CATEGORIES,
  REMAINING_TIME,
} from "../../../helpers/dummies";
import Filter from "../../common/Filter";

const FilterOpportunity = ({filterData ,filter ,reset}) => {
  const [data, setData] = useState({
      categories: [],
      locations: [],
      levels: [],
      nationalities: [],
      duedates: [],
  });

  const onSelected = (selected, option) => {
    setData({ ...data, [option]: [selected] });
  };

  // const onSubmited = (e) => {
  //   let newData={};
  //   e.preventDefault();
  //   // console.log(data)
  //   if (
  //     data.categories.length >0 ||
  //     data.locations.length >0 ||
  //     data.nationalities.length >0 ||
  //     data.levels.length>0
  //   ) {
  //     // console.log(data)
  //      newData={
  //       categories:data?.categories?.length ? data?.categories[0].label : "",
  //       country:data?.locations?.length ? data?.locations[0].value  :"",
  //       nationalities:data?.nationalities?.length ? data?.nationalities[0].label  :"",
  //       levels:data?.levels?.length ? data?.levels[0].label :""
  //      }
  //     filterData(newData)
  //   }
  //   else{
  //     newData={
  //       categories: "",
  //       locations:"",
  //       nationalities:"",
  //       levels:""
  //      }
  //      filterData(newData)
  //   }
  // };

  const onSubmited = (e) => {
    e.preventDefault();
  
    if (
      data.categories.length > 0 ||
      data.locations.length > 0 ||
      data.nationalities.length > 0 ||
      data.levels.length > 0
    ) {
      let newData = {
        categories: data.categories.length ? (data.categories[0]?.label || "") : "",
        country: data.locations.length ? (data.locations[0]?.value || "") : "",
        nationalities: data.nationalities.length ? (data.nationalities[0]?.label || "") : "",
        levels: data.levels.length ? (data.levels[0]?.label || "") : ""
      };
  
      filterData(newData);
    } else {
      let newData = {
        categories: "",
        locations: "",
        nationalities: "",
        levels: ""
      };
  
      filterData(newData);
    }
  }

  const onReseted = () => {
    setData({
      categories: [],
      locations: [],
      levels: [],
      nationalities: [],
      duedates: [],
    });
    reset()
  };

  // useEffect(() => {
  //   console.log('Current State:', data);
  // }, [data]);
console.log("filter",filter)
  return (
    <Filter
      withReset
      onReseted={onReseted}
      withSubmit
      withShadow
      onSubmited={onSubmited}
    >
      <Col lg={2} sm={12}>
        <Form.Group className="mb-0">
          <Selecter
            key={JSON.stringify(data)}
            id="categories"
            name="categories"
            placeholder="Catégorie"
            selecterClasses="filters-selects"
            selecterClassesPrefix="filters-selects-prefix"
            selected={data.categories || []}
            // options={OPP_CATEGORIES}
            options={filter.categories}
            onSelected={onSelected}
          />
        </Form.Group>
      </Col>
      <Col lg={2} sm={12}>
        <Form.Group className="mb-0">
          <Selecter
            key={JSON.stringify(data)}
            id="locations"
            name="locations"
            placeholder="Pays"
            selecterClasses="filters-selects"
            selecterClassesPrefix="filters-selects-prefix"
            selected={data.locations || []}
            // options={LOCATIONS}
            options={filter.countries}
            onSelected={onSelected}
          />
        </Form.Group>
      </Col>
      <Col lg={2} sm={12}>
        <Form.Group className="mb-0">
          <Selecter
            key={JSON.stringify(data)}
            id="levels"
            name="levels"
            placeholder="Éducation min."
            selecterClasses="filters-selects"
            selecterClassesPrefix="filters-selects-prefix"
            selected={data.levels || []}
            // options={LEVELS}
            options={filter.formationlevel}
            onSelected={onSelected}
          />
        </Form.Group>
      </Col>
      <Col lg={2} sm={12}>
        <Form.Group className="mb-0">
          <Selecter
            key={JSON.stringify(data)}
            id="nationalities"
            name="nationalities"
            placeholder="Nationalité(s)"
            selecterClasses="filters-selects"
            selecterClassesPrefix="filters-selects-prefix"
            selected={data.nationalities || []}
            // options={NATIONALITIES}
             options={filter.nationality}
            onSelected={onSelected}
          />
        </Form.Group>
      </Col>
      <Col lg={2} sm={12}>
        <Form.Group className="mb-0">
          <Selecter
            key={JSON.stringify(data)}
            id="duedates"
            name="duedates"
            placeholder="Temps restant"
            selecterClasses="filters-selects"
            selecterClassesPrefix="filters-selects-prefix"
            selected={data.duedates || []}
            options={DUE_DATES}
            onSelected={onSelected}
          />
        </Form.Group>
      </Col>
    </Filter>
  );
};
export default FilterOpportunity;
